module.exports = __webpack_public_path__ + "img/adminHeader.c4ef74ce.png";